import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Row } from "./shared";

export const CatalogueTab = ({ d, setPart }) => (
  <div
    className="mt-6 rounded-lg border border-zinc-800 bg-zinc-900 p-5"
    data-testid="drawing-catalogue"
  >
    <Row label="Default stone group" hint="Applied to new quotes">
      <Input
        data-testid="catalogue-group"
        value={d.catalogue.stone_group}
        onChange={(e) => setPart("catalogue", { stone_group: e.target.value })}
        className="h-11 w-40 border-zinc-800 bg-zinc-950 text-sm"
      />
    </Row>
    <Row label="Default thickness">
      <Select
        value={d.catalogue.thickness}
        onValueChange={(v) => setPart("catalogue", { thickness: v })}
      >
        <SelectTrigger
          data-testid="catalogue-thickness"
          className="h-11 w-40 border-zinc-800 bg-zinc-950 text-sm"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {["2cm", "3cm", "1cm"].map((t) => (
            <SelectItem key={t} value={t}>
              {t}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Row>
  </div>
);
